import React from "react"
import { Check } from "lucide-react"

const Checkbox = ({ checked, onChange, children }) => {
  return (
    <button
      type="button"
      onClick={onChange}
      aria-pressed={checked}
      className="flex items-center gap-2.5 w-full text-left py-1.5 group"
    >
      <span
        className={`flex items-center justify-center w-4 h-4 rounded shrink-0 border transition-colors ${
          checked
            ? "bg-[#FF6B3D] border-[#FF6B3D]"
            : "border-[#DCE1E8] group-hover:border-[#FF6B3D]"
        }`}
      >
        {checked && <Check size={11} strokeWidth={3} className="text-white" />}
      </span>
      <span className="text-sm text-[#26303D]">{children}</span>
    </button>
  )
}

export default Checkbox
